/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { gql } from "@apollo/client";
import Command from "../../../Basis/Commands/Command";
import Schriftart from "../Queries/Schriftart";

export interface AendereTeilnahmeEinstellungenInput {
    teilnahmeEinstellungenId: string;
    logoDateiname?: string;
    logoDateiBase64?: string;
    logoAufHintergrundDateiname?: string;
    logoAufHintergrundDateiBase64?: string;
    rechtliches?: string;
    rechtlichesEN?: string;
    schriftfarbe?: string;
    sekundaerfarbe?: string;
    primaerfarbe?: string;
    geaendert: string;
    schriftart: Schriftart;
    anmeldebestaetigungHinweise: string;
    anmeldebestaetigungHinweiseEN: string;
    eMailHinweise: string;
    eMailHinweiseEN: string;
    agbUrl?: string;
    agbUrlEN?: string;
    datenschutzUrl?: string;
    datenschutzUrlEN?: string;
    impressumUrl?: string;
    impressumUrlEN?: string;
    fusstext?: string;
    fusstextEN?: string;
    bannerDateiname?: string;
    bannerBase64?: string;
    bannerNurAufSucheAnzeigen: boolean;
    homepageTitel?: string;
    homepageTitelEN?: string;
    faviconBase64?: string;
    faviconDateiname?: string;
    suchauswahlImSeitenkopf: boolean;
    sepaVorankuendigungUeberLanCloudVersenden: boolean;
    archivAnzeigen: boolean;
    geschlechtDiversAnzeigen: boolean;
    ustHinweisAnzeigen: boolean;
    deutschlandAlsVorauswahl: boolean;
}

export default class AendereTeilnahmeEinstellungen extends Command<void, AendereTeilnahmeEinstellungenInput> {
    public static readonly commandName = "Teilnahmen_AendereTeilnahmeEinstellungen";

    private static readonly mutation = gql`
        mutation ${AendereTeilnahmeEinstellungen.commandName}($input: ${AendereTeilnahmeEinstellungen.commandName}) {
            ${AendereTeilnahmeEinstellungen.commandName}(input: $input)
        }
    `;

    public constructor(refetchQueries: string[] = []) {
        super(AendereTeilnahmeEinstellungen.mutation, refetchQueries);
    }

    public get name(): string {
        return AendereTeilnahmeEinstellungen.commandName;
    }
}